import toast from "react-hot-toast";
import { clientRoutes } from "../routes";
import axiosInstance from "./Axios";

export class TemplatesApi {
  static getTemplates = async () => {
    try {
      const res = await axiosInstance.get(
        `client/subscriptions/user-subscription`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getDesignTemplateById = async (templateId: string) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/design_templates/${templateId}`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getDesignActivities = async (params: {
    page: number;
    search?: string;
    limit?: number;
    subscription_type?: string;
    property_id?: string;
    listing_type?: string;
    post_type?: string;
    start_date?: string;
    end_date?: string;
    status?: string;
    created_at?: string;
    agent_id?: string;
  }) => {
    const {
      page,
      search,
      limit = 20,
      status = "",
      end_date = "",
      post_type = "",
      start_date = "",
      property_id = "",
      listing_type = "",
      created_at = "desc",
      subscription_type = "",
      agent_id = "",
    } = params;
    try {
      const res = await axiosInstance.get(
        `client/design-templates/design-activities`,
        {
          params: {
            page,
            limit,
            search,
            status,
            subscription_type,
            property_id,
            listing_type,
            post_type,
            start_date,
            end_date,
            created_at,
            agent_id,
          },
        }
      );

      return {
        data: res.data?.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getTemplateConfigs = async ({
    subscription_type,
    listing_type,
  }: {
    subscription_type: string;
    listing_type: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/template-configs`,

        {
          params: {
            listing_type,
            subscription_type,
          },
        }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyAnnouncementTemplates = async ({
    announcement_type,
  }: {
    announcement_type?: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/agency-announcement-templates`,
        {
          params: {
            announcement_type,
          },
        }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyfestivalTemplates = async ({
    festival_type,
  }: {
    festival_type?: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/design-templates/agency-festival-templates`,
        {
          params: {
            festival_type,
          },
        }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static createReviewPost = async (data: any) => {
    try {
      const res = await axiosInstance.post(`review-posts`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: err?.response?.data?.message || "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetReviewPosts = async (
    params: {
      page?: number;
      limit?: number;
      review_post_title?: string;
      post_status?: string;
      post_type?: string;
      start_date?: string;
      end_date?: string;
    } = {}
  ) => {
    try {
      const res = await axiosInstance.get(`review-posts/get-review-posts`, {
        params: {
          ...params,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static GetReviewPostById = async (review_post_id: string) => {
    try {
      const res = await axiosInstance.get(
        `review-posts/get-review-posts/${review_post_id}`
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static updateReviewPost = async (data: any, review_post_id: string) => {
    try {
      const res = await axiosInstance.put(
        `review-posts/${review_post_id}`,
        data
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getStandardTemplates = async ({
    page,
    template_type_id,
    post_type,
    listing_type,
    subscription_type,
    announcement_type,
    festival_type,
    limit = "30",
  }: {
    page: number;
    template_type_id: string;
    post_type: string;
    listing_type: string;
    subscription_type: string;
    announcement_type?: string;
    festival_type?: string;
    limit?: string | number;
  }) => {
    try {
      const params: any = {
        page,
        limit,
        created_at: "desc",
        template_type_id,
        post_type,
        listing_type,
        subscription_type,
      };

      if (announcement_type) {
        params.announcement_type = announcement_type;
      }

      if (festival_type) {
        params.festival_type = festival_type;
      }

      const res = await axiosInstance.get(
        `client/design-templates/standard-templates`,
        { params }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyPersonalizedTemplates = async ({
    page,
    template_type_id,
    post_type,
    listing_type,
    subscription_type,
    announcement_type,
    festival_type,
    limit = "30",
  }: {
    page: number;
    template_type_id: string;
    post_type: string;
    listing_type: string;
    subscription_type: string;
    announcement_type?: string;
    festival_type?: string;
    limit?: string | number;
  }) => {
    try {
      const params: any = {
        page,
        limit,
        created_at: "desc",
        template_type_id,
        post_type,
        listing_type,
        subscription_type,
      };

      if (announcement_type) {
        params.announcement_type = announcement_type;
      }

      if (festival_type) {
        params.festival_type = festival_type;
      }

      const res = await axiosInstance.get(
        `/client/design-templates/agencypersonalized-templates`,
        { params }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getBrandTemplates = async ({
    page,
    template_type_id,
    post_type,
    subscription_type,
    listing_type,
    announcement_type,
    festival_type,
    limit = "30",
  }: {
    page: number;
    template_type_id: string;
    post_type: string;
    subscription_type: string;
    listing_type: string;
    announcement_type?: string;
    festival_type?: string;
    limit?: string | number;
  }) => {
    try {
      const params: any = {
        page,
        limit,
        created_at: "desc",
        template_type_id,
        post_type,
        listing_type,
        subscription_type,
      };

      if (announcement_type) {
        params.announcement_type = announcement_type;
      }

      if (festival_type) {
        params.festival_type = festival_type;
      }

      const res = await axiosInstance.get(
        `client/design-templates/pro-templates`,
        { params }
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static setTemplate = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/design-templates/set-template`,
        data
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteTemplateConfig = async (configId: string) => {
    try {
      const res = await axiosInstance.delete(
        `client/design-templates/design-template-config/${configId}`
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong!",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getFestivalTypes = async ({
    search = "",
    page = 1,
    limit = 30,
    created_at = "desc",
  }: {
    search?: string;
    page?: number;
    limit?: number;
    created_at?: string;
  }) => {
    try {
      const res = await axiosInstance.get("festival-types", {
        params: {
          search,
          page,
          limit,
          created_at,
        },
      });

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };
}
